import React, {useEffect, useMemo, useState} from 'react';
import TableSkeleton from "../../components/skeletons/TableSkeleton";
import RecordsMessage from "../../components/RecordsMessage";
import DatePicker from "../../components/DatePicker";
import TableSelect from "../../components/TableSelect";
import Pagination from "../../components/Pagination";
import TransactionDetails from "../../components/TransactionDetails";
import StatementOfAccountAPI from "../../api/StatementofAccountsAPI";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faGreaterThan, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import UtcToLocal from "../../components/UtcToLocal";
import {
    capitalizeFirstLetters,
    formatAccount,
    formatSignedCurrency
} from "../../features/ValueFormater";
import {useRowSelect, useTable} from "react-table";
import {Checkbox} from "../../components/Checkbox";
import OverviewAPI from "../../api/OverviewAPI";
import ExportButton from "../../components/ExportButton";
import {useSelector} from "react-redux";

function SoaTemplate({currencyId}) {
    const [GetStatementDataList, SetStatementDataList] = useState([]);
    const [totalNbPage, SetTotalNbPage] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1);
    const [visible, setVisible] = useState(false);
    const [amountDetails, setAmountDetails] = useState(0);

    const {GetSOAList, GetStatementData, totalNbOfPage, totalCount, soaLoading} = StatementOfAccountAPI();
    const {
        GetAccountBalance,
    } = OverviewAPI();
    const {flag} = useSelector((state) => state.transferResponse);

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    const [dateString, setDateString] = useState([]);
    const [transactionType, setTransactionType] = useState("All");

    useEffect(() => {
        if (dateRange) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);
            setDateString({
                startDateString,
                endDateString
            })
            GetSOAList(currencyId, 1, startDateString, endDateString, transactionType);
            GetAccountBalance(startDateString, endDateString);
            setVisible(false);
        }
    }, [dateRange, transactionType, flag]);


    useEffect(() => {
        if (GetStatementData) {
            SetStatementDataList(GetStatementData);
            SetTotalNbPage(totalNbOfPage);
        }
    }, [GetStatementData]);


    const data = useMemo(() => GetStatementDataList, [GetStatementDataList]);

    const [activeRowIndex, setActiveRowIndex] = useState(-1);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const columns = useMemo(
        () => [
            {
                Header: "Transaction",
                accessor: "Transaction",
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Payment Date",
                accessor: "PaymentDate",
                Cell: ({cell: {value}}) => {
                    return <UtcToLocal utcTimestamp={value} options={options}/>
                },
            },
            {
                Header: "Type",
                accessor: "Method",
            },
            {
                Header: `Amount (${currencyId === 1 ? "$" : "L.L"})`,
                accessor: "Amount",
                Cell: ({value, row}) => {
                    const sign = row.original.Sign;
                    if (sign === "+") {
                        return <span style={{
                            color: "green",
                            fontFamily: "Poppins Bold ",
                            fontSize: "14px"
                        }}>+{formatAccount(value, currencyId)}</span>;
                    } else if (sign === "-") {
                        if(row.original.Status?.toLowerCase()==="pending"){
                            return <span style={{
                                color: "#D3AA00",
                                fontFamily: "Poppins Bold ",
                                fontSize: "14px"
                            }}>-{formatAccount(value, currencyId)}</span>;
                        }
                        return <span style={{
                            color: "red",
                            fontFamily: "Poppins Bold ",
                            fontSize: "14px"
                        }}>-{formatAccount(value, currencyId)}</span>;
                    } else {
                        return formatAccount(value, currencyId);
                    }
                },
            },
            {
                Header: `Balance (${currencyId === 1 ? "$" : "L.L"})`,
                accessor: "Balance",
                Cell: ({cell: {value}}) => {
                    const sign = Math.sign(value);
                    return <span className="semi-bold-text">{formatSignedCurrency(value, currencyId, sign)}</span>
                },
            },
            {
                Header: `Beneficiary`,
                accessor: `Beneficiary`,
                Cell: ({value}) => {
                    return capitalizeFirstLetters(value);
                }
            },
            {
                Header: "Status",
                accessor: "Status",
                Cell: ({cell: {value}}) => {
                    if (value.toLowerCase() === "pending") {
                        return <button style={{
                            color: "white",
                            fontFamily: "Poppins Medium ",
                            fontSize: "14px",
                            backgroundColor: "#D3AA00",
                            borderRadius: "20px",
                            width: "120px",
                            padding: "5px 0"
                        }}>{capitalizeFirstLetters(value)}</button>;
                    } else if (value?.toLowerCase() === "approved") {
                        return <button style={{
                            color: "white",
                            fontFamily: "Poppins Medium ",
                            fontSize: "14px",
                            backgroundColor: "#199B2D",
                            borderRadius: "20px",
                            width: "120px",
                            padding: "5px 0"
                        }}>{capitalizeFirstLetters(value)}</button>;
                    } else if (value?.toLowerCase() === "declined" || value?.toLowerCase() === "rejected") {
                        return <button style={{
                            color: "white",
                            fontFamily: "Poppins Medium ",
                            fontSize: "14px",
                            backgroundColor: "#D32127",
                            borderRadius: "20px",
                            width: "120px",
                            padding: "5px 0"
                        }}>{capitalizeFirstLetters(value)}</button>;
                    } else if (value?.toLowerCase() === "reversed") {
                        return <button style={{
                            color: "white",
                            fontFamily: "Poppins Medium ",
                            fontSize: "14px",
                            backgroundColor: "#D32127",
                            borderRadius: "20px",
                            width: "120px",
                            padding: "5px 0"
                        }}>{capitalizeFirstLetters(value)}</button>;
                    } else {
                        return <UtcToLocal utcTimestamp={value} options={options}/>;
                    }
                },
            },
            {
                Header: "",
                accessor: "AS",
                Cell: ({row}) => {
                    return <button onClick={() => {
                        setAmountDetails({
                            Amount: row.original.Amount,
                            Balance: row.original.Balance,
                            Method: row.original.Method,
                            PaymentDate: row.original.PaymentDate,
                            Transaction: row.original.TransferID,
                        })
                        setVisible(true)
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faGreaterThan}/></button>;
                },
            }
        ],
        []
    );

    const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, selectedFlatRows} =
        useTable({columns, data}, useRowSelect,
            (hooks) => {
                hooks.visibleColumns.push((columns) => {
                    return [
                        {
                            id: 'selection',
                            Header: ({getToggleAllRowsSelectedProps}) => (
                                <Checkbox {...getToggleAllRowsSelectedProps()} />
                            ),
                            Cell: ({row}) => (
                                <Checkbox {...row.getToggleRowSelectedProps()} />
                            )
                        },
                        ...columns,
                    ]
                })
            });

    const [searchQuery, setSearchQuery] = useState("");

    const filteredRows = rows.filter((row) => {
        return Object.values(row.original).some((cellValue) => {
            return cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
        });
    });

    return (
        <>
            <div className={activeRowIndex === -1 ? "col-10" : "col-8"}>
                <div className="tableTop">
                    <RecordsMessage totalNbPage={totalNbPage} selectedPage={selectedPage} totalCount={totalCount}
                                    records="transactions"/>
                    <div className="filtering">
                        <div className="filteringSearch">
                            <input
                                className="search"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <span className="iconSeacrch"><FontAwesomeIcon icon={faMagnifyingGlass}/></span>
                        </div>

                        <div className="DatePicker">
                            <DatePicker
                                value={dateRange}
                                onChange={setDateRange}
                            />
                        </div>
                        <select
                            className="ddselect"
                            name="account"
                            id="account"
                            onChange={(e) => {
                                setActiveRowIndex(-1)
                                setVisible(false);
                                setSelectedPage(1);
                                setTransactionType(e.target.value);
                            }}
                        >
                            <option value="All">All Transactions</option>
                            <option value="BankTransfer">Bank Transfer</option>
                            <option value="Exchange">Exchange</option>
                            <option value="SuyoolToSuyool">Suyool To Suyool</option>

                        </select>
                        <ExportButton
                            CurrencyID={currencyId}
                            dateFrom={dateString.startDateString}
                            dateTo={dateString.endDateString}
                            transactionType={transactionType}
                            selectedRows={selectedFlatRows}
                        />
                    </div>
                </div>
                {soaLoading ? (
                    <>
                        <TableSkeleton/>
                    </>
                ) : (
                    <>
                        <TableSelect
                            headerGroups={headerGroups}
                            page={filteredRows}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            activeRowIndex={activeRowIndex}
                            setActiveRowIndex={setActiveRowIndex}
                            setAmountDetails={setAmountDetails}
                            setVisible={setVisible}
                            totalNbPage={totalNbPage}
                        />

                        <Pagination
                            getData={GetSOAList}
                            CurrencyID={currencyId}
                            totalNbPage={totalNbPage}
                            method="soa"
                            endDateString={dateString.endDateString}
                            startDateString={dateString.startDateString}
                            transactionType={transactionType}
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                    </>
                )
                }
            </div>

            <TransactionDetails
                activeRowIndex={activeRowIndex}
                setActiveRowIndex={setActiveRowIndex}
                visible={visible}
                setVisible={setVisible}
                TransactionID={amountDetails}
            />
        </>
    );
}

export default SoaTemplate;